import React, { useEffect, useMemo, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { SiGoogleforms } from "react-icons/si";
import { FaRegHandshake } from "react-icons/fa6";
import { FiUsers } from "react-icons/fi";
import { RiUserSettingsLine } from "react-icons/ri";
import { ACLS, CATEGORY_ORDER, CEO_GROUP, COMMERCIAL_HEAD_GROUP, FACILITY_MANAGER_GROUP, FINANCE_MANAGER_GROUP, PORTOS_CUSTOMER_GROUP, TECHNICIAN_GROUP } from "../../Config";
import { commercialHeadGetAllFacilitiesForNav } from '../../Redux/Actions/Actions'; // Adjust the import path as necessary
import { getGroupName } from "../Reusable_Components/ReusableFunctions"
import { useDispatch, useSelector } from 'react-redux';

let brandLogo = "./images/bellbell.svg";



export default function LeftNavBar({ children, menuActive }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const [aclsValue, setAclsValue] = useState();
  const [activeImageListChead, setactiveImageListChead] = useState();
  const [groupedNavItems, setGroupedNavItems] = useState({});


  const getGroupNameOriginal = (val) => {
    switch (val) {
      case "Commercial Head":
        return COMMERCIAL_HEAD_GROUP;
      case "Technician":
        return TECHNICIAN_GROUP;
      case "Finance Manager":
        return FINANCE_MANAGER_GROUP;
      case "Facility Manager":
        return FACILITY_MANAGER_GROUP;
      case "CEO":
        return CEO_GROUP;
      case "Customer":
        return PORTOS_CUSTOMER_GROUP;
      default:
        return "";
    }
  };

  const groupName = getGroupNameOriginal(localStorage.getItem('group'));
  const categoryOrder = CATEGORY_ORDER[groupName] || [];
  useEffect(() => {
    const group = localStorage.getItem('group');
    let navItems = [];

    switch (group) {
      case "Commercial Head":
        navItems = ACLS.IndoPortCommercialHeadGroup;
        break;
      case "Technician":
        navItems = ACLS.IndoPortTechnicianGroup;
        break;
      case "Finance Manager":
        navItems = ACLS.IndoPortFinanceManagerGroup;
        break;
      case "CEO":
        navItems = ACLS.IndoPortCEOGroup;
        break;
      case "Facility Manager":
        navItems = ACLS.IndoPortFacilityManagerGroup;
        break;
      case "View Only User":
        navItems = ACLS.PortosViewOnlyUser;
        break;
      case "Customer":
        navItems = ACLS.PortOSCustomerGroup;
        break;
      default:
        navItems = [];
    }

    const grouped = {}
    navItems.forEach(item => {
      const category = item.CATEGORY || "Other";
      if (!grouped[category]) grouped[category] = [];
      grouped[category].push(item);
    });
    setGroupedNavItems(grouped);
  }, []);





  return (
    <div className={`left-navbar${menuActive ? ' menu-active' : ''}`} style={{ zIndex: 9999 }}>
      {Object.entries(groupedNavItems)
        .sort((a, b) => {
          if (categoryOrder.length) {
            return categoryOrder.indexOf(a[0]) - categoryOrder.indexOf(b[0]);
          }
          return 0;
        })
        .map(([category, items]) => (
          <div key={category} style={{ marginBottom: '0' }}>
            <div className="leftNavBarCategory-wrapper">

              <span className='leftNavBarCategory'>{category}</span>

            </div>
            {items.map((item, index) => (
              <NavLink to={item.ROUTE} key={index}
                // onClick={() => window.location.reload()}

                onClick={() => {
                  dispatch(commercialHeadGetAllFacilitiesForNav())

                }}
                className={location.pathname === item.ROUTE ? 'activeLeftNavItems' : 'leftNavItems'}>
                <img src={item.IMGSRC} alt={item.ALT} className={location.pathname === item.ROUTE ? 'active' : ''} />
                <span className='iconText'>{item.ALT}</span>
              </NavLink>
            ))}
          </div>
        ))};
    </div>
  );
};
